import { render } from "./messagNotice.vue?vue&type=template&id=3d03befa"
import script from "./messagNotice.vue?vue&type=script&lang=js"
export * from "./messagNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__